export const isSuccessStatusCode = (statusCode) => {
    return statusCode >= 200 && statusCode < 400;
};
export const __platforms = ['__universal__'];
//# sourceMappingURL=http_util.js.map